/* newtestdesign · the cart page (sections/ntd-cart.liquid)
   Shopify draws the cart; this keeps it up to date in place through Shopify's Cart API (NTD.cart in
   ntd.js): − / + (quick taps on a line → one request), a typed quantity and Remove → /cart/change.js,
   the order note → /cart/update.js. Every answer is the whole cart, and the lines, the summary, the
   empty cart and the "Add a sticker sheet?" band are drawn again from it — the section's markup and
   words ([data-cart-words]). A cart changed elsewhere on the page (the drawer, "+ Add" on the shelf)
   arrives as ntd.js's "ntd:cart" event; on this page "+ Add" doesn't open the drawer.
   Phones: a bar with the total and Check out while the summary's own button is out of sight. */
(function () {
  "use strict";
  var doc = document, root = doc.querySelector("[data-cartpage]");
  if (!root || !window.fetch) return;
  var $ = function (s) { return root.querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };
  var box = doc.createElement("textarea");
  var dec = function (s) { box.innerHTML = s; return box.value; };
  var esc = function (s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); };
  var f = function (s, o) { return String(s || "").replace(/\{(\w+)\}/g, function (m, k) { return o[k] != null ? o[k] : m; }); };
  var W = {};
  try { W = JSON.parse($("[data-cart-words]").textContent); } catch (e) {}
  Object.keys(W).forEach(function (k) { W[k] = dec(W[k]); });       // Shopify sends translations HTML-escaped
  var ICON = {
    minus: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M5 12h14"/></svg>',
    plus: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M12 5v14M5 12h14"/></svg>'
  };
  var N = {}, T = {};                                                  // window.NTD and its words, once ntd.js has run

  /* prices as nd-money writes them: "QAR 15", or "15 ر.ق" kept in one piece in Arabic */
  var money = function (c) { var m = esc(N.money(c)); return N.lang === "ar" ? "<bdi>" + m + "</bdi>" : m; };
  var sized = function (src, w) { return /\/cdn\/shop\/|cdn\.shopify\.com/.test(src) ? src + (src.indexOf("?") > -1 ? "&" : "?") + "width=" + w : src; };
  /* the builder's grid for a sheet and its sticker size (as the section) */
  var grid = function (sheet, size) {
    var g = sheet === "A3" ? { L: [5, 8], M: [6, 10], S: [8, 10] } : { L: [4, 6], M: [5, 8], S: [5, 10] };
    return g[size] || g.L;
  };
  /* a library sticker from where its picture lives (theme assets or Files), the other place as the fallback;
     a sticker the shop added itself ("m…") from the address the order carries */
  function sticker(id, pics, cls) {
    var c = cls ? ' class="' + cls + '"' : "";
    if (/^m/.test(id)) return pics[id] ? "<img" + c + ' src="' + esc(pics[id]) + '" alt="" loading="lazy">' : "";
    return "<img" + c + ' src="' + esc(N.stickerImg(id)) + '" data-alt="' + esc(N.stickerImg(id, true)) + '" onerror="this.onerror=null;this.src=this.dataset.alt" alt="" loading="lazy" width="40" height="40">';
  }

  function lineHTML(it, i) {
    var p = it.properties || {};
    var ids = String(p["_Sticker IDs"] || "").split(",").map(function (x) { return x.trim(); }).filter(Boolean);
    var design = String(p["_Design ID"] || "").trim();
    var isSheet = it.handle === "custom-sticker-sheet", isBig = it.handle === "big-sticker" && !!design;
    var sheet = /a3/i.test(it.variant_title || "") ? "A3" : "A4";
    var url = isSheet ? N.builder : isBig ? N.builderLink("mode=big&design=" + encodeURIComponent(design)) : it.url;
    var pics = {};
    String(p["_Sticker pictures"] || "").split(" ").forEach(function (x) { var k = x.indexOf("="); if (k > 0) pics[x.slice(0, k)] = x.slice(k + 1); });

    var ph = "";
    if (isSheet && ids.length) {
      var g = grid(sheet, String(p._Sizes || "L").charAt(0).toUpperCase()), cells = "";
      for (var k = 0; k < g[0] * g[1]; k++) cells += "<i>" + (ids[k] ? sticker(ids[k], pics) : "") + "</i>";
      ph = '<span class="ntd-paper ntd-cline__paper' + (sheet === "A3" ? " is-a3" : "") + '" style="--c:' + g[0] + ";--r:" + g[1] + '">' + cells + "</span>";
    } else if (isBig) {
      ph = /^m/.test(design) ? (p["_Design picture"] ? '<img class="ntd-cline__design" src="' + esc(p["_Design picture"]) + '" alt="" loading="lazy">' : "") : sticker(design, pics, "ntd-cline__design");
    } else if (it.image) {
      ph = '<img src="' + esc(sized(it.image, 240)) + '" alt="" loading="lazy">';
    }

    var v = "";
    if (isSheet) v = esc(W.sheet) + ': <bdi dir="ltr">' + sheet + "</bdi> · " + esc(f(ids.length === 1 ? T.stickers_one : T.stickers_other, { n: ids.length }));
    else if (isBig) v = esc(W.design) + ": <bdi>" + esc(p.Design || "") + '</bdi> · <bdi dir="ltr">' + esc(it.variant_title || "") + "</bdi> " + esc(W.cm);
    else if (!it.product_has_only_default_variant && it.variant_title && !/default title/i.test(it.variant_title)) v = esc(it.variant_title);
    var props = Object.keys(p).filter(function (k) { return k.charAt(0) !== "_" && p[k] && ["Stickers", "Sheet", "Design"].indexOf(k) < 0; })
      .map(function (k) { return '<p class="ntd-cline__prop">' + esc(k) + ": " + esc(p[k]) + "</p>"; }).join("");
    var names = p.Stickers ? String(p.Stickers).split(" | ") : [];
    var namesHTML = names.length ? '<details class="ntd-cline__names"><summary>' + esc(f(W.names, { n: names.length })) + '</summary><ul lang="en" dir="ltr">' +
      names.map(function (n) { return "<li>" + esc(n) + "</li>"; }).join("") + "</ul></details>" : "";
    var each = it.quantity > 1 ? '<p class="ntd-cline__each">' + f(esc(W.each), { price: money(it.final_price) }) + "</p>" : "";
    var offs = (it.line_level_discount_allocations || []).map(function (a) {
      return '<p class="ntd-cline__off">' + esc((a.discount_application || {}).title) + " (−" + money(a.amount) + ")</p>";
    }).join("");
    var t = it.product_title, rm = String((N.routes || {}).change || "/cart/change.js").replace(/\.js$/, "") + "?line=" + (i + 1) + "&quantity=0";

    return '<article class="ntd-cline' + (isSheet ? " is-sheet" : "") + '" data-line="' + (i + 1) + '" data-key="' + esc(it.key) + '">' +
      '<a class="ntd-cline__ph" href="' + esc(url) + '" tabindex="-1" aria-hidden="true">' + ph + "</a>" +
      '<div class="ntd-cline__info"><a class="ntd-cline__t" href="' + esc(url) + '">' + esc(t) + "</a>" + (v ? '<p class="ntd-cline__v">' + v + "</p>" : "") + props + namesHTML + each + offs + "</div>" +
      '<div class="ntd-cline__qty"><div class="ntd-cqty">' +
        '<button type="button" data-step="-1" aria-label="' + esc(f(W.less, { title: t })) + '">' + ICON.minus + "</button>" +
        '<input type="number" name="updates[]" value="' + (+it.quantity) + '" min="0" inputmode="numeric" dir="ltr" data-qty aria-label="' + esc(f(W.qty, { title: t })) + '">' +
        '<button type="button" data-step="1" aria-label="' + esc(f(W.more, { title: t })) + '">' + ICON.plus + "</button>" +
      '</div><a class="ntd-cline__rm" href="' + esc(rm) + '" data-remove>' + esc(W.remove) + "</a></div>" +
      '<p class="ntd-cline__price">' + (it.original_line_price > it.final_line_price ? "<s>" + money(it.original_line_price) + "</s>" : "") + "<b>" + money(it.final_line_price) + "</b></p>" +
      "</article>";
  }

  var sig = function (c) { return c.item_count + "-" + c.total_price + "-" + c.items.map(function (i) { return i.key + ":" + i.quantity + ";"; }).join(""); };
  function render(c) {
    if (!c || !c.items) return;
    var empty = !c.item_count;
    $("[data-cart-full]").hidden = empty;
    $("[data-cart-empty]").hidden = !empty;
    var band = $("[data-cart-band]");
    if (band) band.hidden = empty || c.items.some(function (i) { return i.handle === "custom-sticker-sheet"; });
    var line = $("[data-cart-line]");
    if (line) { line.hidden = empty; line.textContent = f(c.item_count === 1 ? T.items_one : T.items_other, { n: c.item_count }); }
    if (!empty) {
      $("[data-cart-lines]").innerHTML = c.items.map(lineHTML).join("");
      $("[data-sum-items]").innerHTML = money(c.items_subtotal_price);
      $("[data-sum-total]").innerHTML = money(c.total_price);
      var bt = $("[data-bar-total]");
      if (bt) bt.innerHTML = money(c.total_price);
      $$("[data-sum-off]").forEach(function (x) { x.remove(); });
      var before = $("[data-sum-delivery]");
      (c.cart_level_discount_applications || []).forEach(function (d) {
        var row = doc.createElement("div");
        row.className = "is-off"; row.setAttribute("data-sum-off", "");
        row.innerHTML = "<dt>" + esc(d.title) + "</dt><dd>−" + money(d.total_allocated_amount) + "</dd>";
        before.parentNode.insertBefore(row, before);
      });
    }
    // the shelf leaves out what's already in the cart
    var inCart = c.items.map(function (i) { return String(i.product_id); });
    $$("[data-product-id]").forEach(function (s) { s.hidden = inCart.indexOf(s.getAttribute("data-product-id")) > -1; });
    $$("[data-cart-count]", doc).forEach(function (el) { el.textContent = c.item_count; });
    root.setAttribute("data-sig", sig(c));
    barCheck();
  }

  var msg = function (text) { var m = $("[data-cart-msg]"); if (m) m.textContent = text || ""; };
  function change(row, qty) {
    row.classList.add("is-busy");
    msg("");
    N.cart.change(row.getAttribute("data-key"), qty).then(function (c) {
      render(c);
      if (!qty && N.toast) N.toast(T.removed || "Removed from your cart");
    }).catch(function () {
      row.classList.remove("is-busy");
      msg(W.fail || "Couldn't update your cart — please try again.");
    });
  }
  root.addEventListener("click", function (e) {
    var step = e.target.closest("[data-step]");
    if (step) {
      var row = step.closest("[data-key]"), input = row.querySelector("[data-qty]");
      var q = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute("data-step"), 10));
      input.value = q;
      clearTimeout(row.__t);                                           // quick taps on one line → one request
      row.__t = setTimeout(function () { change(row, q); }, 350);
      return;
    }
    var rm = e.target.closest("[data-remove]");
    if (rm) { e.preventDefault(); change(rm.closest("[data-key]"), 0); }
  });
  root.addEventListener("change", function (e) {
    var t = e.target;
    if (t.matches("[data-qty]")) change(t.closest("[data-key]"), Math.max(0, parseInt(t.value, 10) || 0));
    else if (t.matches("[data-note]") && N.cart) N.cart.update({ note: t.value }).catch(function () {});
  });
  root.addEventListener("keydown", function (e) {      // Enter in a quantity box changes that line, not the whole form
    if (e.key === "Enter" && e.target.matches && e.target.matches("[data-qty]")) { e.preventDefault(); e.target.blur(); }
  });

  var bar = $("[data-cart-bar]");
  function barCheck() {
    if (!bar) return;
    var go = $(".ntd-csum__go"), r = go && go.getBoundingClientRect();
    var on = !!r && window.innerWidth <= 900 && !$("[data-cart-full]").hidden && (r.top > window.innerHeight - 40 || r.bottom < 70);
    bar.classList.toggle("is-on", on);
  }
  window.addEventListener("scroll", barCheck, { passive: true });
  window.addEventListener("resize", barCheck);

  function init() {
    N = window.NTD || {}; T = N.t || {};
    if (!N.cart) return;
    N.noDrawer = true;
    doc.addEventListener("ntd:cart", function (e) { render(e.detail); });
    // the cart now vs the one Shopify drew (changed in another tab, or the preview's pretend cart)
    N.cart.get().then(function (c) { if (sig(c) !== root.getAttribute("data-sig")) render(c); else barCheck(); }).catch(function () {});
    barCheck();
  }
  // ntd.js (the cart helpers) runs after this deferred script; DOMContentLoaded comes after both
  if (window.NTD && window.NTD.cart) init(); else doc.addEventListener("DOMContentLoaded", init);
})();
